import { faCreditCard } from '@fortawesome/free-regular-svg-icons/faCreditCard';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons/faPiggyBank';

export const CREDIT_CARD = faCreditCard;
export const WALLET = faWallet;
export const BANK_TRANSFER = faPiggyBank;

export const PAYMENT_ICONS = [CREDIT_CARD, WALLET, BANK_TRANSFER];
